/**
 * Tier Limits Configuration — single source of truth
 * Used by web (AuthContext.js), mobile (AuthContext.js), and backend.
 */

export const TIER_LIMITS = {
  explorer: {
    // Free tier — "good enough to get users interested"
    // 5 trips/quarter is ~20/year; plenty for casual travelers.
    // Save + watermarked PDF + all transit modes unlock word-of-mouth loops.
    // 30-day trip history retention creates conversion urgency tied to user value.
    itinerariesPerQuarter: 5,
    destinationRecommendations: 10,
    modificationsPerItinerary: 15,
    allowComplexModifications: false,   // "update ALL days" stays paid — power-user marker
    canSaveItineraries: true,           // ✅ unlocked — core of free-tier retention story
    canExportPDF: true,                 // ✅ unlocked — watermarked "Made with arrivo"
    canUseGroupPlanning: false,         // paid — genuine pro feature
    canUseBookingIntegration: false,    // paid — affiliate monetization surface
    canUsePointsOptimization: false,    // paid — high-value pro feature
    responsePriority: 'standard',
    // Feature gates — upsell on interactive features, not on quality
    venueDetailsOnExpand: true,         // Keep venue reviews — drives perceived value + upgrades
    allTransitModes: true,              // ✅ unlocked — little lost, less friction
    // NEW: retention story
    tripHistoryRetention: 30,           // days — auto-archive after 30 days (vs paid = forever)
    canScheduleAutoRefresh: false,      // paid — live weather/flight updates
    maxCollaborators: 1,                // view-only companion
  },
  planner: {
    // Paid tier ($12/mo, $120/yr) — "uncapped, saved forever, collaborative"
    // Unlimited volume is the headline. Collaboration, booking, and points
    // optimization are the true differentiators.
    itinerariesPerQuarter: 999999,      // unlimited (was 4)
    destinationRecommendations: 999999, // unlimited (was 20)
    modificationsPerItinerary: 999999,  // unlimited (was 200)
    allowComplexModifications: true,
    canSaveItineraries: true,
    canExportPDF: true,                 // unwatermarked
    canUseGroupPlanning: true,
    canUseBookingIntegration: true,
    canUsePointsOptimization: true,
    responsePriority: 'priority',       // queue priority, SAME LLM as free (no Sonnet switch)
    venueDetailsOnExpand: true,
    allTransitModes: true,
    // NEW: the uncapped-experience flags
    tripHistoryRetention: 'unlimited',  // never auto-archive
    canScheduleAutoRefresh: true,       // weather/flight live updates
    maxCollaborators: 10,               // group planning ceiling
  },
  admin: {
    itinerariesPerQuarter: 999999,
    destinationRecommendations: 999999,
    modificationsPerItinerary: 999999,
    allowComplexModifications: true,
    canSaveItineraries: true,
    canExportPDF: true,
    canUseGroupPlanning: true,
    canUseBookingIntegration: true,
    canUsePointsOptimization: true,
    responsePriority: 'priority',
    venueDetailsOnExpand: true,
    allTransitModes: true,
    // NEW: mirror planner flags
    tripHistoryRetention: 'unlimited',
    canScheduleAutoRefresh: true,
    maxCollaborators: 999999,
  },
  'super-admin': {
    itinerariesPerQuarter: 999999,
    destinationRecommendations: 999999,
    modificationsPerItinerary: 999999,
    allowComplexModifications: true,
    canSaveItineraries: true,
    canExportPDF: true,
    canUseGroupPlanning: true,
    canUseBookingIntegration: true,
    canUsePointsOptimization: true,
    responsePriority: 'priority',
    venueDetailsOnExpand: true,
    allTransitModes: true,
    // NEW: mirror planner flags
    tripHistoryRetention: 'unlimited',
    canScheduleAutoRefresh: true,
    maxCollaborators: 999999,
    // Super-admin exclusive
    canViewAnalytics: true,
    canViewAdminDashboard: true,
    canViewBudgetTracker: true,
  },
};
